import { useEffect, useState } from "react";

type UseuseCountDownProps = {
    initiatedAt: Date;
    duration: number;
};

export const useCountdown = ({ initiatedAt, duration }: UseuseCountDownProps) => {
    const [timeLeft, setTimeLeft] = useState({ minutes: 0, seconds: 0 });
    const [hasExpired, setHasExpired] = useState(false);

    useEffect(() => {
        const targetTime = new Date(initiatedAt).getTime() + duration * 60000;

        const updateCountdown = () => {
            const now = new Date().getTime();
            const diff = targetTime - now;

            if (diff <= 0) {
                setHasExpired(true);
                setTimeLeft({ minutes: 0, seconds: 0 });
                return;
            }

            const minutes = Math.floor(diff / 60000);
            const seconds = Math.floor((diff % 60000) / 1000);

            setTimeLeft({ minutes, seconds });
            setHasExpired(false);
        };

        updateCountdown();
        const interval = setInterval(updateCountdown, 1000);

        return () => clearInterval(interval);
    }, [initiatedAt, duration]);

    const formattedTimeLeft = `${String(timeLeft.minutes).padStart(2, "0")}:${String(timeLeft.seconds).padStart(
        2,
        "0"
    )}`;

    return { hasExpired, timeLeft: formattedTimeLeft };
};
